import React from 'react'


import {
  classnames,
  Icon,
  VisibilityOff,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'

import { NOOP } from 'Utils/stableDefaults'

function ModelCardOverlay({
  isImageAgeRestricted = false,
  isGalleryOpened = false,
  onClick = NOOP,
  locale = 'en',
}) {
  // The i18next singleton stays on lng 'en' (non-EN rails bundles are only registered, never
  // activated), so the call must name the page locale explicitly or the label renders English
  // on /de, /fr, ... - same contract as the card's action tooltips.
  const previewingLabel = i18n.t('listingPage.gallery.previewing', { ns: 'rails', lng: locale })

  // The overlay is display: none unless one of the two modifiers applies, so the icon renders only
  // where it can show. Every card in a results grid otherwise shipped its ~1 KB inline SVG.
  let content = null
  if (isGalleryOpened) {
    content = previewingLabel
  } else if (isImageAgeRestricted) {
    content = <Icon notSpaced color="light" svgComponent={VisibilityOff} />
  }

  return (
    <span
      className={classnames(
        'card-3d-model__overlay',
        isGalleryOpened && 'card-3d-model__overlay--gallery-opened',
        isImageAgeRestricted && 'card-3d-model__overlay--image-age-restricted'
      )}
      onClick={onClick}
    >
      {content}
    </span>
  )
}

ModelCardOverlay.propTypes = {
  isImageAgeRestricted: bool,
  isGalleryOpened: bool,
  onClick: func,
  locale: string,
}

const mapStateToProps = (context) => ({ locale: context?.locale })

export default WithTriangleUiContext(mapStateToProps)(ModelCardOverlay)
